import Crop from "@/components/Crop";
import { useCurrentUser } from "@/services/hooks";
import { uploadUserFile } from "@/services/upload";
import { Edit } from "@mui/icons-material";
import { Avatar, Box, Button, Skeleton } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import AlertSnackbar from "@/components/AlertSnackbar";

export default function ProfileImage() {
  const { data: currentUser, isLoading } = useCurrentUser();
  const [file, setFile] = useState(null);
  const [editing, setEditing] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const queryClient = useQueryClient();

  const metaKey = "profile";
  const imgUrl = file
    ? URL.createObjectURL(file)
    : currentUser?.meta?.[metaKey];

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setEditing(true);
  };

  const mutation = useMutation({
    mutationFn: (blob) => uploadUserFile(blob, metaKey),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["current_user"] });
      setShowSnackbar(true);
    },
  });

  const onDone = (blob) => {
    mutation.mutate(blob);
    setFile(blob);
    setEditing(false);
  };

  if (editing) {
    return (
      <Crop
        file={file}
        setFile={setFile}
        setEditing={setEditing}
        cropShape="round"
        onDone={onDone}
      />
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 0,
      }}
    >
      <AlertSnackbar
        showSnackbar={showSnackbar}
        setShowSnackbar={setShowSnackbar}
      />
      {isLoading ? (
        <Skeleton variant="circular" width={70} height={70} />
      ) : (
        <Avatar
          src={imgUrl}
          sx={{
            width: 70,
            height: 70,
            border: 1,
            borderColor: "#04FFFF",
            borderStyle: "solid",
          }}
        />
      )}

      <label htmlFor={metaKey}>
        <Button
          variant="text"
          size="small"
          color="primary"
          component="span"
          startIcon={<Edit />}
          disabled={mutation.isPending}
        >
          Edit
        </Button>
      </label>
      <input
        accept="image/*"
        style={{ display: "none" }}
        id="profile"
        type="file"
        onChange={handleFileChange}
      />
    </Box>
  );
}
